import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = ({ pageRange }) => {
    const height = 200 * pageRange
    const body = new Array(pageRange).fill(null).map((i, ind) => {
        const item0 = ind ? 20 + 200 * ind : 20,
            item1 = ind ? 98 + 200 * ind : 98,
            item2 = ind ? 87 + 200 * ind : 87,
            item3 = ind ? 175 + 200 * ind : 175

        return (
            <React.Fragment key={ind}>
                <rect x='15' y={item0} rx='3' ry='3' width='15' height='15' />
                <rect x='35' y={item0} rx='3' ry='3' width='280' height='15' />
                <rect x='615' y={item0} rx='3' ry='3' width='65' height='15' />

                <rect x='15' y={item1} rx='3' ry='3' width='15' height='15' />
                <rect x='35' y={item1} rx='3' ry='3' width='140' height='15' />
                <rect x='185' y={item2} rx='3' ry='3' width='180' height='38' />
                <rect x='615' y={item1} rx='3' ry='3' width='65' height='15' />

                <rect x='15' y={item3} rx='3' ry='3' width='15' height='15' />
                <rect x='35' y={item3} rx='3' ry='3' width='105' height='15' />
                <rect x='615' y={item3} rx='3' ry='3' width='65' height='15' />
            </React.Fragment>
        )
    })

    return (
        <ContentLoader
            speed={2}
            width={708}
            height={height}
            viewBox={`0 0 708 ${height}`}
            backgroundColor='#f3f3f3'
            foregroundColor='#ecebeb'
        >
            <>
                {body}
            </>
        </ContentLoader>
    )
}

export default Loader